package nl.volleyplanner.api.client.planner

import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import nl.volleyplanner.api.entities.OrganisationSeason

class OrganisationEndpoint(val httpClient: HttpClient, val organisationCode: String) {
    val plannerConfiguration = PlannerConfigurationEndpoint(httpClient, "/${organisationCode}")

    val admin = OrganisationAdminEndpoint(httpClient, "/${organisationCode}")
    val persons = PersonAndGroupsEndpoint(httpClient, "/${organisationCode}")
    val groups = GroupsEndpoint(httpClient, "/${organisationCode}")
    val pageTokens = PageTokensClientEndpoint(httpClient, "/${organisationCode}")

    suspend fun getSeasons(): List<OrganisationSeason> = httpClient.get("/${organisationCode}/seasons").body()
}

class HeavyOrganisationEndpoint(val httpClient: HttpClient, val organisationCode: String) {
    val plannerConfiguration = HeavyPlannerConfigurationEndpoint(httpClient, "/${organisationCode}")
}